import template from './PriorityContainerView.html';
import { PriorityContainerController } from './PriorityContainerController';
export const PriorityContainerComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: PriorityContainerController,
    controllerAs: '$ctrl',
    template: template,
    bindings: {
        data: '<',
        application: '<',
        canEditRule: '<',
        canSeeRule: '<',
        queue: '<',
        onEdit: '&?',
        onDelete: '&?',
        onCancel: '&?',
        onChange: '&?',
        elementId: '@?',
    },
};
